export const selectMentees = state => state.mentee.mentees;
export const selectMenteeLoading = state => state.mentee.isLoadingMentee;
export const selectMenteeAvailableStatuses = state => state.mentee.availableStatuses;
